/* global axios */

import ApiClient from '../ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }

  // The SSO handshake stays under integrations, alongside builder, dstudio and analytics.
  getLoginLink() {
    return axios.get(`${this.baseUrl()}/integrations/forms/url`);
  }

  // Only a published form can be turned into a link, so the pickers never offer the rest.
  getFormsList() {
    return axios.get(this.url, { params: { status: 'published' } });
  }

  // Feeds the `Form response` conditions of the form_response_submitted automation event.
  getFormFields(formPublicId) {
    return axios.get(`${this.url}/${formPublicId}/fields`);
  }

  getFormLink(formPublicId, conversationId) {
    return axios.post(`${this.url}/${formPublicId}/links`, {
      conversation_id: conversationId,
    });
  }

  // Used from the new conversation screen, where no conversation exists yet and the contact is
  // resolved from the details typed into the To field.
  getContactFormLink(formPublicId, inboxId, contact) {
    return axios.post(`${this.url}/${formPublicId}/links`, {
      inbox_id: inboxId,
      contact,
    });
  }
}

export default new FormsAPI();
